<div class="container grid-lg">
  <div class="columns">
    <div class="column">

      <header>
        <div class="header-container">
          <!-- LOGO -->
          <div class="logo">
            <a routerLink="/">
              <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo">
              <div *ngIf="!logoUrl">
                <span class="billet text-bold fs-32">inter</span>
                <span class="expressen text-bold fs-32">ticket</span>
              </div>
            </a>
          </div>

          <!-- DESKTOP LINKS -->
          <div class="hide-md">
            <ng-container *ngTemplateOutlet="navLinks"></ng-container>
          </div>
        </div>

        <div class="header-container right-side">
          <!-- MOBILE MENU -->
          <material-icon class="mobile-menu-toggler show-md" (click)="showMobileMenu()">menu</material-icon>

          <!-- MOBILE SEARCH TOGGLER -->
          <material-icon class="search show-md" (click)="showMobileSearchBar = !showMobileSearchBar">
            {{ showMobileSearchBar ? 'close' : 'search' }}
          </material-icon>

          <!-- DESKTOP SEARCH BAR -->
          <div class="hide-md search-bar">
            <ng-container *ngTemplateOutlet="searchBar"></ng-container>
          </div>

          <!-- DESKTOP LANGUAGE PICKER -->
          <div class="hide-md">
            <lib-language-picker></lib-language-picker>
          </div>

          <!-- CART BUTTON -->
          <button class="header-btn cart-btn btn btn-primary btn-sm" routerLink="/cart">
            <material-icon class="cart-icon">shopping_cart</material-icon>
            {{ (cart$ | async)?.totalAmount || 0 }}
          </button>

          <!-- USER PROFILE DROPDOWN -->
          <lib-profile-dropdown></lib-profile-dropdown>
        </div>
      </header>

    </div>
  </div>
</div>

<div class="sublogo-bar">
  <div class="container grid-lg">
    <div class="columns">
      <div class="column">
        <div class="sublogo">
          <a *ngIf="platformLabelImage || platformLabel[0] || platformLabel[1]" routerLink="/">
            <span class="by fs-10 px8" *ngIf="showBy">by </span>
            <img class="platform-image" src="/assets/interticket_logo_white.png" alt="interticket" *ngIf="platformLabelImage">
            <span class="fs-15 text-bold billet">{{ platformLabel[0] }}</span>
            <span class="expressen">{{ platformLabel[1] }}</span>
          </a>
          <a *ngIf="showGiftCardMenu" routerLink="/card" (click)="closeMobileMenu()">
            <material-icon>card_giftcard</material-icon>
            <span class="fs-15 text-bold billet">{{ 'stemx_card_type_giftcard' | translate }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MOBILE SEARCH BAR -->
<div *ngIf="showMobileSearchBar" [@showSearchBarAnimation]="showMobileSearchBar">
  <div class="show-md">
    <ng-container *ngTemplateOutlet="searchBar"></ng-container>
  </div>
</div>

<!-- SIDENAV -->
<app-custom-sidebar class="show-md header-sidebar" [isOpen]="isShowMobileMenu" (onClose)="closeMobileMenu()">
  <div class="sidebar-menu mobile-sidebar-menu">
    <h4>{{ 'general_lang_menu' | translate }}</h4>
    <ng-container *ngTemplateOutlet="navLinks"></ng-container>

    <lib-language-picker></lib-language-picker>
  </div>
</app-custom-sidebar>

<!-- SEARCH BAR TEMPLATE -->
<ng-template #searchBar>
  <form class="searchbar-form" [formGroup]="searchBarForm" appForm (ngSubmit)="onSearch()" novalidate autocomplete="off">
    <div class="search-bar">
      <input class="text-input" appFormControl type="text" formControlName="searchFilter" autocomplete="off" placeholder="{{ 'lang_label_search' | translate }}">
      <material-icon (click)="onSearch()">search</material-icon>
    </div>
  </form>
</ng-template>

<!-- NAV LINKS -->
<ng-template #navLinks>
  <a routerLink="/event" class="header-link" routerLinkActive="active-link" (click)="closeMobileMenu()">{{ 'label_events' | translate }}</a>
  <a routerLink="/contact" class="header-link" routerLinkActive="active-link" (click)="closeMobileMenu()">{{ 'label_contact' | translate }}</a>
</ng-template>

<!-- TIMER ENDED MODAL -->
<app-custom-modal id="cartTimerExpiredModal" [title]="'stemx_cart_expired_title'" [isOpen]="isModalOpen" (onClose)="closeCartTimerExpiredModal()">
  <p modal-body class="text-dark">{{ 'stemx_cart_expired_description' | translate }}</p>
  <button modal-footer type="button" class="btn btn-primary" (click)="closeCartTimerExpiredModal()">{{ 'label_done' | translate }}</button>
</app-custom-modal>

<!-- CONCURRENT PLAYBACK MODAL -->
<app-custom-modal id="concurrentPlaybackModal" [title]="'switch_to_this_device'" [isOpen]="storeService.isConcurrentPlaybackModalOpen$ | async" (onClose)="storeService.isConcurrentPlaybackModalOpen$.next(false)">
  <p modal-body class="text-dark">{{ 'stemx_concurrent_video_playback_is_not_allowed' | translate }}</p>
  <button modal-footer type="button" class="btn btn-primary" (click)="storeService.isConcurrentPlaybackModalOpen$.next(false)">{{ 'continue_on_other_device' | translate }}</button>
  <button modal-footer type="button" class="btn btn-primary ml16" (click)="storeService.pauseConcurrent$.next(); storeService.isConcurrentPlaybackModalOpen$.next(false)">{{ 'label_yes' | translate }}</button>
</app-custom-modal>

<!-- APPLICATION UPDATED MODAL -->
<app-custom-modal id="appUpdatedModal" [title]="'new_version_available'" [isOpen]="isAppUpdatedModalOpen$ | async" (onClose)="closeAppUpdatedModal()">
  <p modal-body class="text-dark">{{ 'app_updated_page_will_reload' | translate }}</p>
  <button modal-footer type="button" class="btn btn-primary" (click)="closeAppUpdatedModal(true)">{{ 'label_confirm_ok' | translate }}</button>
</app-custom-modal>

<!-- PERMISSION ERROR MODAL -->
<app-custom-modal id="permissionErrorModal" [title]="'permission_error'" [isOpen]="isPermissionErrorOpen$ | async" (onClose)="closePermissionErrorModal()">
  <p modal-body class="text-dark">{{ 'permission_error_page_will_reload' | translate }}</p>
  <button modal-footer type="button" class="btn btn-primary" (click)="closePermissionErrorModal(true)">{{ 'label_confirm_ok' | translate }}</button>
</app-custom-modal>
